import {
  BREAKPOINTS_V3,
  TypographyV3,
  useMediaQuery,
} from '@jouzen/ecom-components';
import { useReducedMotion } from 'framer-motion';
import { useTranslations } from 'next-intl';

import Motion, { type MotionProps } from '@/app/components/Motion';

import type { SectionContentProps } from './SectionContent';

export interface SectionContentBodyProps
  extends Pick<SectionContentProps, 'content'> {
  readonly isActive: boolean;
}

export const getMotionProps = ({
  isActive,
  isLargeBreakpoint,
  reducedMotion,
}: {
  isActive: boolean;
  isLargeBreakpoint: boolean;
  reducedMotion: boolean;
}): MotionProps => {
  return isLargeBreakpoint
    ? {
        animate: {
          opacity: isActive ? 1 : 0,
          y: 0,
          transitionEnd: {
            opacity: isActive ? 1 : 0,
            y: Boolean(reducedMotion) || isActive ? 0 : 50,
          },
        },
        initial: {
          opacity: isActive ? 1 : 0,
          y: reducedMotion ? 0 : 50,
        },
        transition: {
          duration: 1,
        },
      }
    : {
        initial: {
          opacity: 0,
          y: 0,
        },
        transition: {
          delay: 0.2,
          duration: 0.75,
        },
        viewport: {
          once: true,
        },
        whileInView: {
          opacity: 1,
        },
      };
};

const SectionContentBody = ({
  content,
  isActive,
}: SectionContentBodyProps): JSX.Element => {
  const t = useTranslations();
  const isLargeBreakpoint = useMediaQuery(
    `(min-width: ${BREAKPOINTS_V3.large}px)`,
  );
  const reducedMotion = useReducedMotion();
  const motionProps = getMotionProps({
    isActive,
    isLargeBreakpoint: Boolean(isLargeBreakpoint),
    reducedMotion: Boolean(reducedMotion),
  });

  return (
    <Motion {...motionProps} className="relative z-20">
      <TypographyV3 color="inherit">{t.rich(content)}</TypographyV3>
    </Motion>
  );
};

export default SectionContentBody;
